import { isBefore } from "date-fns"
import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { type AccountCampaignSlug } from "../constants/accountCampaignSlug"

const graphQLFragments = {
    accountCampaign: graphql(`
        fragment isAccountCampaignActive_AccountCampaign on AccountCampaignType {
            expiryDate
            slug
        }
    `),
}

export function isAccountCampaignActive(
    fragment: FragmentOf<typeof graphQLFragments.accountCampaign>,
    campaignSlug: AccountCampaignSlug
) {
    const accountCampaign = readFragment(graphQLFragments.accountCampaign, fragment)

    return (
        accountCampaign.slug === campaignSlug &&
        (!accountCampaign.expiryDate || isBefore(new Date(), new Date(accountCampaign.expiryDate)))
    )
}

isAccountCampaignActive.fragments = graphQLFragments
